<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';
import type { Model as JobStopTimestampsFieldsetModel } from '@/components/fieldsets/JobStopTimestampsFieldset.vue';

import { reactive, ref, toRaw } from 'vue';

import JobStopTimestampsFieldset from '@/components/fieldsets/JobStopTimestampsFieldset.vue';
import useForm from '@/composables/useForm';

import tabsStyles from '@/styles/tabs.module.scss';

export interface InitialData {
  timestamps?: JobStopTimestampsFieldsetModel[];
}

export interface ValidData {
  timestamps: JobStopTimestampsFieldsetModel[];
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
  isFutile?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
  isFutile: undefined,
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.timestamps == null) return;
  emit('submit', event, toRaw(formData) as ValidData);
});

const tabNum = ref(1);
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.editTimestampsDialogForm"
    data-testid="editTimestampsDialogForm"
    @submit.prevent="handleSubmit"
  >
    <div :class="[$style.tabs, tabsStyles.tabsWrapper]">
      <v-tabs
        v-model="tabNum"
        :class="tabsStyles.tabs"
        grow
        :show-arrows="false"
      >
        <v-tab
          v-for="(_, stopIndex) in formData.timestamps"
          :key="stopIndex"
          :value="stopIndex + 1"
          :ripple="false"
          :class="tabsStyles.tab"
          variant="plain"
        >
          Stop {{ stopIndex + 1 }}
        </v-tab>
      </v-tabs>
    </div>
    <v-window
      v-if="formData.timestamps"
      v-model="tabNum"
      :class="$style.window"
    >
      <v-window-item
        v-for="(_, stopIndex) in formData.timestamps"
        :key="stopIndex"
        :value="stopIndex + 1"
        :class="$style.window"
      >
        <!-- TODO set boleans for each fieldset base on job prop or model -->
        <JobStopTimestampsFieldset
          v-model="formData.timestamps[stopIndex]"
          :class="$style.jobStopTimestampsFieldset"
          :is-requested="true"
          :is-latest="true"
          :is-estimated="true"
          :is-arrived="true"
          :is-departed="true"
          :is-pod="true"
          :is-assigned="true"
        />
      </v-window-item>
    </v-window>
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.editTimestampsDialogForm {
}
  .tabs {
    margin: 0 variables.$pageDialogWindowPaddingX 16px variables.$pageDialogWindowPaddingX;
    float: left;

    & + * {
      clear: left;
    }
  }
  .window {
  }
    .jobStopTimestampsFieldset {
      padding: 0 variables.$pageDialogWindowPaddingX;
      margin-top: 15px;
    }
  .field {
  }
</style>
